import { Box, BoxProps, SxProps, useMediaQuery } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { selectComponentStore } from '../../system/PageStore';
import SwipeableViews from 'react-swipeable-views';
import { autoPlay } from "react-swipeable-views-utils";
import { changePopUpStates } from '../../system/Slicer/CommonSlicer';
import { DefaultSetting } from '../defaultSetting';
import { GalleryImageData } from '../../data/GalleryImgDate';

const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

export interface AutoPlaySliderProps extends BoxProps {
    data: Array<GalleryImageData>,
    event: (index: number, lastIndex?: number) => {},
    children?: React.ReactNode,
    width?: string,
    height?: string,
    sx?: SxProps,
}

export function AutoPlaySlider(props: AutoPlaySliderProps) {
    const dispatch = useDispatch();
    const componentStates = useSelector(selectComponentStore);
    const isPc = useMediaQuery('(min-width:600px)');

    return <Box component="div" onMouseLeave={props.onMouseLeave} onMouseEnter={props.onMouseEnter} sx={{ position: "relative", width: 1, height: props.height ?? 1, overflow: "hidden", borderRadius: DefaultSetting.borderRadius, ...props.sx }} >
        <AutoPlaySwipeableViews
            axis="x"
            disableLazyLoading
            enableMouseEvents
            index={componentStates.HomePageComponentReducer.homePageSliderIndex}
            onChangeIndex={props.event}
            style={{ height: "100%", overflow: "hidden" }}
            containerStyle={{ height: "100%" }}
            slideStyle={{ height: "100%", overflow: "hidden" }}
        >
            {props.data.map((item, index) => (
                <Box
                    component="div"
                    key={index}
                    role="button"
                    tabIndex={0}
                    onClick={() => {
                        if (isPc) dispatch(changePopUpStates({ src: item.url }))
                    }}
                    sx={{ width: "100%", height: "100%", overflow: "hidden", cursor: isPc ? "pointer" : "default" }}
                >
                    <Box
                        component="img"
                        src={item.url}
                        sx={{ width: "100%", height: "100%", objectFit: "cover", overflow: "hidden", borderRadius: "5px", display: "block" }}
                    />
                </Box>
            ))}
        </AutoPlaySwipeableViews>
        {props.children}
    </Box>
}